import CustomModal from "../../../core/components/ui/custom-modal.component"
import EditRoleForm from "./edit-role-form.component";

const EditRoleModal = ({row, handleRecordChange, openEdit, setOpenEdit}) => {

    const handleClose = () => setOpenEdit(false);
    
    return(
        <CustomModal  
            open={openEdit}
            handleClose={handleClose}
            title="Edit Role"
        >
            <EditRoleForm handleClose={handleClose} handleRecordChange={handleRecordChange} row={row}/>
        </CustomModal>
    )
}


export default EditRoleModal
